import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdateDeclaracionJuradaCeseActividadDirectaByID = () => {
  const [loadingUpdateDeclaracionJuradaCeseActividadDirectaById, setLoadingCreateDeclaracionJuradaCeseActividadDirecta] = useState(false);
  const [successUpdateDeclaracionJuradaCeseActividadDirectaById, setSuccessCreateDeclaracionJuradaCeseActividadDirecta] = useState(false);
  const [errorUpdateDeclaracionJuradaCeseActividadDirectaById, setErrorCreateDeclaracionJuradaCeseActividadDirecta] = useState(null);
  const [dataUpdateDeclaracionJuradaCeseActividadDirectaById, setDataDeclaracionJuradaCeseActividadDirecta] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )


  //UPDATE
  const updateDeclaracionJuradaCeseActividadDirectaById = async (userId:string , formId: string, data:any, _cb?:(data:any)=>void) => {
    setLoadingCreateDeclaracionJuradaCeseActividadDirecta(true);
    setSuccessCreateDeclaracionJuradaCeseActividadDirecta(false);
    setErrorCreateDeclaracionJuradaCeseActividadDirecta(null);

    apiRecord.updateDeclaracionJuradaDirectaByID(userId, formId, data).then((res: any) => {
      setLoadingCreateDeclaracionJuradaCeseActividadDirecta(false);
      setSuccessCreateDeclaracionJuradaCeseActividadDirecta(true);
      setDataDeclaracionJuradaCeseActividadDirecta(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingCreateDeclaracionJuradaCeseActividadDirecta(false);
      setErrorCreateDeclaracionJuradaCeseActividadDirecta(err.response.data)
    })
  }

  return {
    updateDeclaracionJuradaCeseActividadDirectaById,
    loadingUpdateDeclaracionJuradaCeseActividadDirectaById,
    successUpdateDeclaracionJuradaCeseActividadDirectaById,
    errorUpdateDeclaracionJuradaCeseActividadDirectaById,
    dataUpdateDeclaracionJuradaCeseActividadDirectaById
  }

}

export default useUpdateDeclaracionJuradaCeseActividadDirectaByID;
